import { useSelector } from "react-redux";
import Graph from "./Graph";

const MonthlyEntityCountChart = () => {
  const orgSubscriptionCount = useSelector(
    (state) => state.ownerReducer.orgSubscriptionCount
  );

  const getTransformedDataForSubsCount = (orgSubscriptionCount) => {
    const monthMap = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11,
    };

    let transformedResultForOrgSubsCount = [
      {
        name: "Total",
        data: Array(12).fill(0),
      },
    ];
    Object.keys(orgSubscriptionCount).forEach((dateKey) => {
      const [year,month] = dateKey.split("-");
      const monthIndex = monthMap[month.toLowerCase()];

      if (monthIndex >= 0 && monthIndex < 12) {
        transformedResultForOrgSubsCount[0].data[monthIndex] =
          orgSubscriptionCount[dateKey];
      }
    });

    return transformedResultForOrgSubsCount;
  };

  return (
    <div className="py-5">
      <Graph
        colors={["#FECB17", "#D0004B", "#80CBC4"]}
        dataSet={getTransformedDataForSubsCount(orgSubscriptionCount)}
        title={"Newly Registered Mosques"}
      />
    </div>
  );
};

export default MonthlyEntityCountChart;
